import styled from "styled-components";
import HyperLink from "../commonComponents/hyperLink/hyperLink";

export const StyledCheckSerialNumber = styled.div`
  .check-sn-title {
    /* Include heading 5 from mixin.scss*/
    @media (min-width: 960px) {
      font-size: 20px;
      line-height: 22px;
    }
    /* Include end*/

    margin: 16px 0;
    &:after {
      content: "*";
      color: #ef233c;
      padding-left: 5px;
    }
  }
  .section-sn {
    box-shadow: 4px 10px 30px 4px rgb(36 14 47 / 6%);
    border-radius: 12px;
    padding: ${({ theme }) => `${theme.uptimeSpace[6]}px`};
    .label-form {
      font-size: 15px;
      line-height: 15px;
      font-weight: bold;
    }
    .required.label-form::after {
      content: "*";
      color: #ef233c;
      padding-left: 5px;
    }
    .sn-control {
      display: grid;
      position: relative;
      margin-top: 10px;
      grid-template-columns: 100%;
      gap: ${({ theme }) => `${theme.uptimeSpace[5]}px`};
      @media (min-width: 450px) {
        grid-template-columns: 70% 20%;
      }
      @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
        grid-template-columns: 85% 20%;
      }
    }

    .error-msg {
      color: #ef233c;
      font-size: 14px;
      button {
        margin-top: -3px;
        padding: 0;
        background-color: transparent;
        color: #ef233c;
        text-transform: none;
        text-decoration: underline;
        line-height: 1;
        &:hover {
          color: #5f249f;
        }
      }
    }
    .hint-msg {
      font-size: 14px;
      button {
        font-family: ${({ theme }) =>
          `${theme.uptimeFonts.primary}${theme.uptimeFonts.secondary && `,${theme.uptimeFonts.secondary}`} !important`};
        margin-top: -3px;
        padding: 0;
        background-color: transparent;
        text-transform: none;
        text-decoration: underline;
        color: #5f249f;
        line-height: 1;
      }
    }
    .info-user {
      color: #737373;
      line-height: 0.3;
      p {
        font-size: 14px;
      }
    }
    .info-user-noedit {
      min-height: 100px;
    }
    .isLoadingCheckSN {
      width: 24px !important;
      height: 24px !important;
    }
    .icon-success {
      color: #62c370 !important;
    }
  }
  .section-sn.section-sn-check-user {
    box-shadow: none;
    padding: 0;
    .label-form {
      font-size: 16px;
      line-height: 16px;
    }
    .sn-control {
      margin-top: ${({ theme }) => `${theme.uptimeSpace[4]}px`};
    }
  }
`;
export const StyledDeviceDetailForm = styled.div`
  .SN-device-details {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    margin: 0 auto;
    box-sizing: border-box;
    .text-input {
      padding: ${({ theme }) => `${theme.uptimeSpace[5]}px`} 0;
    }
    .device-details-title {
      padding: 10px 0px;
      .uptime-typography {
        font-family: ${({ theme }) =>
          `${theme.uptimeFonts.primary}${theme.uptimeFonts.secondary && `,${theme.uptimeFonts.secondary}`} !important`};
        font-weight: bold;
        font-size: 18px;
      }
    }
    .divider {
      padding: 40px 0px 12px;
    }

    @media (min-width: ${({ theme }) => theme.breakpoints.lg}) {
      .text-input {
        padding: ${({ theme }) => `${theme.uptimeSpace[5]}px`};
      }
    }
  }
`;

export const StyledKBLink = styled(HyperLink)<{ open?: boolean }>(
  ({ theme, open }) => `
    padding-top: 5px;
    margin-left: ${open ? "unset" : "30px"};
    @media (min-width: ${theme.breakpoints.sm}) {
      margin-left: ${open ? "unset" : "100px"};
    }

`
);
